<template>
  <div>
    <div v-if="$root.isEmbeddedMode" class="preview">
      <stl-viewer v-if="src" :src="src" :key="src" fullscreen/>
      <div v-else-if="filename" class="fi-container">
          <div class="fi-wrapper">
            <span :style="{background: iconColor}"
                  class="fileicon fileicon-lg"
            >{{ extension }}</span>
          </div>
          <div class="fi-filename">No preview available</div>
      </div>
    </div>
  </div>
</template>

<script>
import StlViewer from './StlViewer';
import * as util from '../util';

const view = require('../view.js'),
    viewData = {
      isHidden: true,
      isOpen: false,
      activeRequest: false,
      src: '',
      filename: '',
      downloadable: false,
      kind: null,
      baseUrl: null
    },
    resetData = Object.assign({}, viewData);

export default view(viewData, {
  components: {StlViewer},
  props: {
  },
  mounted() {
    this.reset();
    const projectId = this.$parent.viewIndex;
    const [kind, hash, filename] = this.$parent.viewParam?.split('+');

    console.log('projecId', projectId, 'kind', kind, 'filename', filename);
    this.src = `${this.$root.url}project/${projectId}/${kind}/${hash}/${filename}`;
    if (this.$root.embeddedToken) {
      this.src = `${this.src}?token=${this.$root.embeddedToken}`;
    }
    console.log('new src', this.src);
    this.filename = filename;
  },
  computed: {
    isImage() {
      return /\.(png|jpg|jpeg|gif|svg)$/i.test(this.filename)
    },
    isStl() {
      return /\.stl$/i.test(this.filename)
    },
    iconColor() {
      return util.fileIconColor(this.extension);
    },
    extension() {
      return this.filename.split('.').pop() || '';
    }
  },
  methods: {
    reset() {
      for (var i in resetData) {
        if (resetData.hasOwnProperty(i)) {
          if (typeof resetData[i] != 'object' && i != 'isHidden' && i != 'isOpen') {
            viewData[i] = resetData[i];
          }
        }
      }
    },
  }
});
</script>
<style scoped>
  .fileicon {
    display: inline-block;
    color: white;
    padding: 5px;
    text-transform: uppercase;
  }
  .fi-filename {
    text-align: center;
  }
  .attachment-item {
    display: inline-block;
  }
  .fi-container {
    text-align: center;
    vertical-align: middle;
    width: 100%;
    margin: 10px;
    padding: 5px;
  }

  .fi-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 120px;
    line-height: 80px;
    overflow: hidden;
  }

  img {
    max-width: 100%;
  }
</style>
